export default __webpack_public_path__ + "static/lk-ca0ed2de0cd34a176766903a10e22f09.svg";